exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-file-text2[data-v-142a3d7a]{\n\tfont-size: 15rem;\n}\n#easel-preview-image[data-v-142a3d7a]{\n\tmax-height: 200px;\n}\n", ""]);

// exports
